module.exports = __webpack_public_path__ + "static/fonts/Lato-Light.5b761f2d.ttf";